import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  categoryPlural: 'Categories',
  categorySingular: 'Category',
  subcategoryPlural: 'Subcategories',
  subcategorySingular: 'Subcategory',
})
